import React, {Component, useMemo} from 'react';

import {ColumnInstance, Row, useTable} from "react-table";
import {useQueryResponseData, useQueryResponseLoading} from "../core/QueryResponseProvider";
import {usersColumns} from "./colome/_columns";
import {KTCardBody} from "../../../../../_metronic/helpers";
import {PageModel} from "../core/_model";
import {CustomHeaderColumn} from "./colome/CustomHeaderColumn";
import {CustomRow} from "./colome/CustomRow";
import {PageListPagination} from "../components/pagination/PageListPagination";
import {MenuListLoading} from "../../../Menu/Menu_list/components/loading/MenuListLoading";





const PageTable =()=> {
    const users = useQueryResponseData()
    const isLoading = useQueryResponseLoading()
    const data = useMemo(() => users, [users])
    const columns = useMemo(() => usersColumns, [])
    const {getTableProps, getTableBodyProps, headers, rows, prepareRow} = useTable({
    columns,
    data,
})

return (
    <KTCardBody className='py-4'>
        <div className='table-responsive'>
            <table
                id='kt_table_users'
                className='table align-middle table-row-dashed fs-6 gy-5 dataTable no-footer'
                {...getTableProps()}
            >
                <thead>
                <tr className='text-start text-muted fw-bold fs-7 text-uppercase gs-0'>
                    {headers.map((column: ColumnInstance<PageModel>) => (
                        <CustomHeaderColumn key={column.id} column={column} />
                    ))}
                </tr>
                </thead>
                <tbody className='text-gray-600 fw-semibold' {...getTableBodyProps()}>
                {rows.length > 0 ? (
                    rows.map((row: Row<PageModel>, i) => {
                        prepareRow(row)
                        return <CustomRow row={row} key={`row-${i}-${row.id}`} />
                    })
                ) : (
                    <tr>
                        <td colSpan={7}>
                            <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                                چیزی  یافت نشد
                            </div>
                        </td>
                    </tr>
                )}
                </tbody>
            </table>
        </div>
        <PageListPagination />
        {isLoading && <MenuListLoading />}
    </KTCardBody>
)
}

export default PageTable;